import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import store from '../src/api'
import { Provider } from 'react-redux';
import { KeyUri } from './key';
import { initMetaPixel } from "./utils/metaPixel";

initMetaPixel("844415441990068");

window.APP_CONFIG = {
  BACKEND_URI: KeyUri.BACKEND_URI,
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
    <App />
    <ToastContainer />
    </Provider>
    </BrowserRouter>
  </React.StrictMode>
);



if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(registration => {
     
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
